// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import VerifyOtpActionType from './verify-otp.types';

const INITIAL_STATE = {
	// OTP Verify Response
	verifyMemberOtpResponse: null,
	// Resend OTP Response
	resenOtpResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** Otp Verify Mobile Number Start ************************/
		case VerifyOtpActionType.VERIFY_MEMBER_NUMBER_OTP_SUCCESS:
			return { ...state, verifyMemberOtpResponse: action.payload };

		case VerifyOtpActionType.VERIFY_MEMBER_NUMBER_OTP_FAILURE:
			return { ...state, verifyMemberOtpResponse: action.payload };

		case VerifyOtpActionType.VERIFY_MEMBER_NUMBER_OTP_RESPONSE_CHANGED:
			return { ...state, verifyMemberOtpResponse: null, verifyOtpStatus: null };

		/** ***************** Otp Verify Mobile Number End ************************/

		/** ***************** Resend Otp Verify Mobile Number Start ************************/
		case VerifyOtpActionType.RE_SEND_OTP_START_RESPONSE_SUCCESS:
			return { ...state, resenOtpResponse: action.payload };

		case VerifyOtpActionType.RE_SEND_OTP_START_RESPONSE_FAILURE:
			return { ...state, resenOtpResponse: action.payload };

		case VerifyOtpActionType.RE_SEND_OTP_START_RESPONSE_CHANGED:
			return { ...state, resenOtpResponse: null };
		/** ***************** Resend Otp Verify Mobile Number End ************************/

		default:
			return state;
	}
};
